import { MantineThemeOverride } from '@mantine/core'
import { primaryColors } from '../src/tokens/colors'
import size from '../src/tokens/size'
import { Anchor } from 'plugin-mantine-resources/src/components/anchor'
import { Button } from 'plugin-mantine-resources/src/components/button'
import { Checkbox } from 'plugin-mantine-resources/src/components/checkbox'
import { ActionIcon } from 'plugin-mantine-resources/src/components/actionIcon'
import { Input } from 'plugin-mantine-resources/src/components/input'
import { Title } from 'plugin-mantine-resources/src/components/title'
import { Select } from 'plugin-mantine-resources/src/components/select'

export const mantineDefaultProps: MantineThemeOverride = {
    fontFamily: 'var(--fira-font-regular)',
    ...size,
    headings: {
        fontFamily: 'var(--fira-font-semibold)',
        fontWeight: 600
    },
    primaryShade: { light: 6, dark: 7 },
    colors: primaryColors,
    components: {
        Button: Button,
        Anchor: Anchor,
        Checkbox: Checkbox,
        ActionIcon: ActionIcon,
        Input: Input,
        Title: Title,
        Select: Select
    }
}
